import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import HeroVideo from "../../components/HeroVideo";
import icon from "../../assets/images/pops-bangs.gif";
import icon1 from "../../assets/images/start-stop-deactivatie.gif";
import icon2 from "../../assets/images/exhaust-flap-control.gif";
import icon3 from "../../assets/images/check-engine-critical.gif";
import icon4 from "../../assets/images/lambnox.gif";
import icon5 from "../../assets/images/rev-cut.gif";
import icon6 from "../../assets/images/launch-control.gif";
import icon7 from "../../assets/images/dpf-off.gif";
import icon8 from "../../assets/images/egr-off.gif";
import icon9 from "../../assets/images/adblue.gif";

// Service Options Data

const OPTIONS_MAP = {
  "Pop & Bang Crackle map": {
    icon,
    heading: "POPS & BANGS",
    description: (
      <>
        Pops &amp; Bangs heeft zijn naam te danken aan het knallende geluid dat
        uit de uitlaat komt. Deze service is ook wel bekend als Anti-Lag System
        (ALS) of als Exhaust Crackle. Bij deze service blijft de turbo in
        werking wanneer het gaspedaal niet ingedrukt is. Hierdoor zal uw
        voertuig over een snellere reactietijd en een hoger vermogen beschikken.
        Wanneer het gaspedaal wordt losgelaten zal de brandstof ontploffen in de
        uitlaat van het voertuig, wat een knallend geluid met zich meebrengt. In
        sommige gevallen kan dit ook vlammen uit de uitlaat geven.
        <br />
        <br />
        Bij X-TREMETUNINGS kunnen wij deze service toepassen door de software
        van het voertuig aan te passen waardoor de turbo in werking zal blijven.
        Ook kijken wij hierbij de software van het voertuig na en in sommige
        gevallen adviseren wij meerdere aanpassingen bij het afnemen van de
        service Pops &amp; Bangs.
        <br />
        <br />
        Heeft u vragen over deze service of wilt u weten of uw voertuig hiervoor
        in aanmerking komt?
        <br />U kunt contact met ons opnemen via ons{" "}
        <a href="contact">contactformulier</a> of neem{" "}
        <a href="tel:0613100091">telefonisch</a> contact met ons op.
        <br />
        <br />
        <b>LET OP!</b>
        <br />
        Bij deze service zijn soms meerdere aanpassingen nodig!
      </>
    ),
  },
  "START/STOP OFF": {
    icon: icon1,
    heading: "START STOP",
    description: (
      <>
        De Start Stop functie zorgt ervoor dat de auto automatisch afslaat als
        uw voertuig tot stilstand komt en automatisch weer start op het moment
        dat u weer gaat rijden. Dit zorgt ervoor dat de uitstoot van schadelijke
        stoffen vermindert en dat u brandstof bespaart. Vooralsnog vinden velen
        dit niet prettig rijden en willen ze deze functie deactiveren.
        <br />
        <br />
        Bij X-TREMETUNINGS bieden wij de service om de Start Stop functie
        volledig te deactiveren als u het onprettig vindt dat uw auto
        automatisch afslaat en start.
      </>
    ),
  },
  FLAPS: {
    icon: icon2,
    heading: "EXHAUST FLAP CONTROL",
    description: (
      <>
        Exhaust Flap Control geeft u meer controle over het geluid van uw auto.
        Vertrek je op een rustige vroege ochtend en wil je niet iedereen om je
        heen wakker maken of wil je juist jouw aanwezigheid kenbaar maken?
        <br />
        <br />
        Met deze bedieningsfunctie kunt u in alle situaties zonder compromissen
        dezelfde auto gebruiken. Het stelt u in staat om het openen en sluiten
        van de uitlaatklep te veranderen en zogemakkelijk te kiezen tussen
        ingetogen gegorgel van de motor of beestachtig gebrul, afhankelijk van
        de gelegenheid waarin u zich bevindt.
        <br />
        <br />
        Wanneer de uitlaatklep gesloten is, staat de uitlaat in de meer stille
        modus. Wanneer u echter de klep opent, wordt de doorstroming op geen
        enkele manier belemmerd en staat de uitlaat in de meest agressieve
        brullende modus.
      </>
    ),
  },
  "DTC Removal": {
    icon: icon3,
    heading: "DTC REMOVAL",
    description: (
      <>
        Bij het verwijderen van de DTC* worden de foutcodes die uw voertuig
        aangeeft verwijderd. Door deze foutcodes gaat het motorlampje branden in
        uw voertuig. Dit kan soms voorkomen bij het verwijderen van o.a. EGR-
        Klep of Swirl Flaps.
        <br />
        <br />
        Bij X-TREMETUNINGS bieden we u de service om door de software van de ECU
        opnieuw te programmeren de DTC te verwijderen.
        <br />
        <br />
        *DTC; Diagnostic Trouble Code
      </>
    ),
  },
  DECAT: {
    icon: icon4,
    heading: "LAMBDASONDE & NOx SOLUTIONS",
    description: (
      <>
        In de uitlaat van uw auto bevindt zich een sensor dit is de lambdasonde.
        Deze sensor is te vinden bij zowel benzine als dieselmotoren en meet het
        aandeel zuurstof in het uitlaatgas. Het kan voorkomen dat bij het
        monteren van sportcats of decatpijpen in uw uitlaatsysteem uw motorlamp
        gaat branden. Dit kan komen door het ontstaan van emissie fouten in de
        Cat efficiency*.
        <br />
        <br />
        Bij X-TREMETUNINGS bieden we de service om de Lambdasonde te
        deactiveren. Hierbij worden de controles uit de ECU* geschreven.
        <br />
        <br />
        *Cat efficiency, foutcodes P0420 en P0430
        <br />
        *ECU, Electronic Control Unit
      </>
    ),
  },
  Vmax: {
    icon: icon5,
    heading: "V-MAX",
    description: (
      <>
        V-Max is een snelheidsbegrenzer die in veel voertuigen is
        geprogrammeerd. In de meeste gevallen zijn deze begrensd op 250 km,
        hierdoor kunt u niet altijd de topsnelheid van uw auto eruit halen.
        <br />
        <br />
        Bij X-TREMETUNINGS bieden we de service om deze V-Max te deactiveren
        door de software in uw auto opnieuw te programmeren.
      </>
    ),
  },
  "LAUNCH CONTROL": {
    icon: icon6,
    heading: "LAUNCH CONTROL",
    description: (
      <>
        Met Launch Control wordt ervoor gezorgd dat uw voertuig vanuit stilstand
        gemakkelijker de maximale snelheid kan bereiken. Dit heeft te maken met
        uw koppeling en gaspedaal bij het optrekken van uw voertuig.
        <br />
        <br />
        Bij X-TREMETUNINGS bieden wij de service om met een aanpassing in de ECU
        het maximaal aantal toeren dat uw motorblok kan maken te verminderen
        naar een bepaalde waarde.
      </>
    ),
  },
  "EGR OFF": {
    icon: icon8,
    heading: "EGR SOLUTIONS",
    description: (
      <>
        Het EGR (Exhaust Gas Recirculation) systeem zorgt ervoor dat de
        uitlaatgassen opnieuw de verbrandingskamer in gaan. Door dit proces
        wordt de temperatuur van de uitlaatgassen verminderd. Met als gevolg
        minder ontwikkeling van NOx uitstoot, wat weer beter is voor het milieu.
        Dit lijkt in eerste instantie een goede oplossing, maar het EGR systeem
        brengt vaak veel problemen met zich mee.
        <br />
        <br />
        De grootste EGR problemen ontstaan vaak door vervuiling. Uitlaatgassen
        brengen roet met zich mee, dit roet hoopt zich op in diverse
        leidingen/slangen en buizen van de auto. Na enige tijd worden de
        doorgangen, door de flinke laag roet, steeds kleiner. Het gevolg hiervan
        is dat er minder lucht de cilinder in kan. Dit leidt tot
        vermogensverlies, de motor houd in en of stottert tijdens het optrekken,
        het verbruik zal omhoog gaan en vaak gaat ook het storingslampje
        motormanagement branden.
        <br />
        <br />
        Een optie is het reinigen of vervangen van de EGR klep waar vaak hoge
        kosten tegenover staan. Let op, het probleem keert weer terug. Bij
        X-TREMETUNINGS hebben wij de oplossing voor u! Wij passen het
        motormanagement softwarematig aan waarbij de EGR herschreven wordt. Te
        lang doorrijden met een vervuilde EGR kan een vervuiling van andere
        motorcomponenten tot gevolg hebben.
        <br />
        <br />
        Rijd dus niet te lang door met uw EGR probleem en bel ons voor de
        mogelijkheden voor uw auto!
      </>
    ),
  },
  "DPF OFF": {
    icon: icon7,
    heading: "DPF SOLUTIONS",
    description: (
      <>
        DPF* ook wel bekend als roetfilter. Dit is een filter die de
        uitlaatgassen doorlaat en de roetdeeltjes opvangt. Bij hoge temperaturen
        of lange afstanden start uw voertuig automatisch een regeneratieproces
        om de roetdeeltjes te verbranden. Dit gebeurt doordat er een hoeveelheid
        diesel in de roetfilter wordt gespoten en de roetdeeltjes worden
        vernietigd door de extreem hoge temperatuur. Dit heeft natuurlijk
        invloed op uw brandstofgebruik. Bij kortere afstanden of te lage
        temperaturen behaalt het voertuig het regeneratieproces niet, waardoor
        de roetdeeltjes niet optimaal verbranden. Dit kan ervoor zorgen dat uw
        roetfilter verstopt raakt. U kunt er ook voor kiezen om de roetfilter te
        laten reinigen of te vervangen.
        <br />
        <br />
        X-TREMETUNINGS biedt de service aan om de roetfilter compleet uit te
        schakelen. Hierbij zullen wij deze volledig weg programmeren waardoor u
        ook geen foutcodes zal krijgen betreft uw roetfilter.
        <br />
        <br />
        LET OP!
        <br />
        Bij het laten reinigen of vervangen van uw roetfilter is er een kans dat
        het probleem op korte termijn weer terug zal komen. Vandaar dat
        X-TREMETUNINGS de service biedt deze uit te schakelen. Deze service is
        geheel op eigen risico van de klant.
        <br />
        <br />
        Wilt u weten wat wij voor u kunnen doen, neem dan contact met ons op.
        <br />
        <br />
        *DPF; Diesel Partikel Filter
      </>
    ),
  },
  Adblue: {
    icon: icon9,
    heading: "ADBLUE SOLUTIONS",
    description: (
      <>
        Adblue wordt gebruikt bij dieselmotoren om deze schoner te laten rijden.
        De uitstoot van stikstof uit de uitlaat wordt hiermee verminderd. Adblue
        is te vinden in een afzonderlijke tank op vrachtauto’s, (bestel)bussen,
        schepen, landbouwtrekkers en ook personenauto’s met een moderne
        dieselmotor.
        <br />
        <br />
        Bij X-TREMETUNINGS bieden we de service om de Adblue te deactiveren.
        Hierbij wordt de ECU opnieuw geprogrammeerd en zullen we ervoor zorgen
        dat de foutmeldingen op het dashboard niet zullen oplichten.
        <br />
        <br />
        LET OP! Het deactiveren van Adblue is toegestaan op voertuigen voor
        off-road of racing gebruik. Deze service is geheel op eigen risico van
        de klant.
        <br />
        <br />
      </>
    ),
  },
  // Add more mappings as needed...
};

function parseOptions(additional_options) {
  if (!additional_options) return [];
  return additional_options.split(",").map((opt) => opt.trim());
}

function getOptionKey(option) {
  // Try to match the option string to the keys in OPTIONS_MAP
  // This can be improved for fuzzy matching if needed
  if (OPTIONS_MAP[option]) return option;
  // Try to match by partial includes
  const found = Object.keys(OPTIONS_MAP).find((key) =>
    option.toLowerCase().includes(key.toLowerCase())
  );
  return found || null;
}

function CarDetail() {
  const navigate = useNavigate();
  const location = useLocation();

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, []);

  const carDetailRef = useRef(null);
  
  useEffect(() => {
    // Check if mobile screen
    const isMobile = window.innerWidth <= 768;

    if (isMobile && carDetailRef.current) {
      carDetailRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, []);

  const {
    make,
    additional_options,
    torque_standard,
    torque_tuned,
    bhp_standard,
    bhp_tuned,
    bhp_difference,
    torque_difference,
    engine_ecu,
    combi,
  } = location.state || {};

  const optionsArr = parseOptions(additional_options);
  const filteredOptions = optionsArr
    .map((opt) => {
      const key = getOptionKey(opt);
      return key ? { ...OPTIONS_MAP[key], key } : null;
    })
    .filter(Boolean);

  return (
    <>
      <HeroVideo />

      {make ? (
        <section>
          <div className="container mx-auto px-6 md:px-10"  ref={carDetailRef}>
            {/* Main Data */}
            <div>
              <div className="">
                <h2 className="text-2xl font-bold ml-4 sm:ml-0 md:text-center text-red-600 mt-14 mb-5">
                  {combi}
                </h2>
              </div>

              {/* <hr className="w-[45%]" /> */}
              <div className="md:flex md:flex-row justify-center gap-4 ">
                <div>
                  {/* Desktop Table */}
                  <p className="text-xl font-bold text-red-500 pb-5 ">
                    Chiptuning Stage 1
                  </p>
                  <div className="overflow-x-auto">
                    <table>
                      <tbody>
                        <tr className="border-y border-gray-200">
                          <td></td>
                          <td className="pl-10 py-4">
                            <b>STANDAARD</b>
                          </td>
                          <td className="pl-10 py-4">
                            <b>NA TUNING</b>
                          </td>
                          <td className="pl-10 py-4">
                            <b>VERSCHIL</b>
                          </td>
                        </tr>
                        <tr className="border-b border-gray-200">
                          <td>
                            <b>VERMOGEN</b>
                          </td>
                          <td className="pl-10 py-4">{bhp_standard}</td>
                          <td className="pl-10 py-4">{bhp_tuned}</td>
                          <td className="pl-10 py-4 text-red-600 font-bold">
                            +{bhp_difference}
                          </td>
                        </tr>
                        <tr className="border-b border-gray-200">
                          <td>
                            <b>KOPPEL</b>
                          </td>
                          <td className="pl-10 py-4">{torque_standard}</td>
                          <td className="pl-10 py-4">{torque_tuned}</td>
                          <td className="pl-10 py-4 text-red-600 font-bold">
                            +{torque_difference}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div></div>
              </div>

              {/* <div className="block sm:hidden">
              
              <div>
                <b className="table_values text-dark mb-1">VERMOGEN</b>
                <table className="table table_values">
                  <tbody>
                    <tr>
                      <td className="text-dark">
                        <b>STANDAARD</b>
                      </td>
                      <td className="text-dark" nowrap="">
                        <b>NA TUNING</b>
                      </td>
                      <td className="text-dark">
                        <b>VERSCHIL</b>
                      </td>
                    </tr>
                    <tr>
                      <td className="bhp_standard">340pk</td>
                      <td className="bhp_tuned">375pk</td>
                      <td className="bhp_difference leader text_gradient">
                        +35pk
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="table-responsive d-sm-none">
                <b className="table_values text-dark mb-1">KOPPEL</b>
                <table className="table table_values">
                  <tbody>
                    <tr>
                      <td className="text-dark">
                        <b>STANDAARD</b>
                      </td>
                      <td className="text-dark" nowrap="">
                        <b>NA TUNING</b>
                      </td>
                      <td className="text-dark">
                        <b>VERSCHIL</b>
                      </td>
                    </tr>
                    <tr>
                      <td className="torque_standard">500Nm</td>
                      <td className="torque_tuned">560Nm</td>
                      <td className="torque_difference leader text_gradient">
                        +60Nm
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div> */}
              <div className="">
                <p className="text-md font-bold my-3">ENGINE ECU</p>
                <p className="text-dark" id="engine_ecu">
                  {engine_ecu}
                </p>
              </div>
              {/* https://github.com/mikhus */}
              {/* <div className="col-md-6">
              <div id="gauge-wrapper" style={{ minHeight: "280px" }}>
                <div
                  id="gauge"
                  className="position-relative"
                  style={{ minHeight: "324px" }}
                >
                  <div
                    id="gauge-nm-wrapper"
                    className="d-inline position-absolute position-bottom-left"
                  >
                    <canvas
                      id="gauge-nm"
                      width="337"
                      height="337"
                      style={{ width: "270px", height: "270px" }}
                    ></canvas>
                  </div>
                  <div
                    id="gauge-ps-wrapper"
                    className="d-inline position-absolute position-z-index"
                    style={{ marginLeft: "-108px", marginTop: "-162px" }}
                  >
                    <canvas
                      id="gauge-ps"
                      width="405"
                      height="405"
                      style={{ width: "324px", height: "324px" }}
                    ></canvas>
                  </div>
                </div>
              </div>
            </div> */}
              <div className="">
                <p className="text-md font-bold my-3">OVERIGE OPTIES</p>

                {/* SERVICE OPTIONS  */}

                <div className="flex flex-col sm:flex-row flex-wrap">
                  {/* Dynamic Service Options */}

                  {filteredOptions.map((opt) => (
                    <div
                      className="text-center w-[100%] sm:w-[30%] lg:w-[25%]"
                      key={opt.key}
                    >
                      <div className="flex justify-center mt-5">
                        <img
                          src={opt.icon}
                          alt={opt.heading}
                          className="bg-white border-[12px] border-black rounded-full min-w-32 max-w-32"
                        />
                      </div>
                      <div className="text w-100">
                        <h3 className="heading my-2 font-medium">
                          {opt.heading}
                        </h3>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              {/* Contact Button */}

              <div className="flex justify-center my-10">
                <button
                  onClick={() => navigate("/contact-us", { state: { combi } })}
                  className="font-bold bg-red-600 px-4 py-3 hover:text-white cursor-pointer"
                >
                  Offerte aanvragen
                </button>
              </div>

              {/* Service Descriptions */}

              <div className="text-dark">
                {/* Dynamic Data */}
                {filteredOptions.map((opt) => (
                  <div key={opt.key}>
                    <h4 className="py-2">
                      <b className="text-red-600 text-2xl">{opt.heading}</b>
                    </h4>
                    <div className="mb-4">{opt.description}</div>
                  </div>
                ))}
              </div>

              {/* Second Contact Button */}
              {filteredOptions.length > 1 && (
                <div className="flex justify-center my-10 pb-10">
                  <button
                    onClick={() =>
                      navigate("/contact-us", { state: { combi } })
                    }
                    className="font-bold bg-red-600 px-4 py-3 hover:text-white cursor-pointer"
                  >
                    Offerte aanvragen
                  </button>
                </div>
              )}
            </div>
          </div>
        </section>
      ) : (
        <div className="flex flex-col justify-center items-center my-10 pb-10">
          <p className="mb-3">Please First Select a Car...</p>
          <button
            onClick={() => navigate("/", { state: { scrollToForm: true } })}
            className="font-bold bg-red-600 px-4 py-3 hover:text-white cursor-pointer"
          >
            Search Vehicle
          </button>
        </div>
      )}
    </>
  );
}

export default CarDetail;
